import { Usecase } from '@core/model/framework/usecase';
import type { ClerkService, FailCaseServiceInput } from '@core/model/service/clerkService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type FailCaseInput = FailCaseServiceInput;
export type FailCaseOutput = void;

@injectable()
export class FailCase implements Usecase<FailCaseInput, FailCaseOutput> {
  constructor(
    @inject(SERVICE_ID.clerkService)
    private readonly clerkService: ClerkService
  ) {}

  async execute(input: FailCaseInput): Promise<FailCaseOutput> {
    await this.clerkService.failCase(input);
  }
}
